import { Empty } from "antd";
import React from "react";

export const NoRequest = (prop) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "65vh",
      }}
    >
      <Empty
        description={`You do not currently have any  ${prop.status} for ${prop.asset} asset in ${prop.year}`}
      />
    </div>
  );
};

